const RolePageLangKey = [
	'btn_add_new',
	'btn_delete_multiple_items'
] as const

type IRolePageLangKey = typeof RolePageLangKey[number]

export type IRolePageLang = {
	role_page: Record<IRolePageLangKey, string>
}

const langEntries = RolePageLangKey.map(
	(key: IRolePageLangKey) => [key, `role_page.${key}`]
)

const langObj: Record<IRolePageLangKey, string> = Object.fromEntries(langEntries)

export const ROLE_PAGE_LANG_KEY: IRolePageLang = {
	role_page: langObj
}
